import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import ActionButton from '@components/ActionButton';

import {
  sxStyles,
  StyledCareerCard,
  StyledOverallFitWrap,
  StyledCareerDetails,
  StyledActionsContainer,
  StyledMoreLink,
} from './CareerCard.styles';

export const InfographicItemSkeleton = () => {
  return (
    <Stack spacing={1} alignItems="center">
      <Skeleton variant="rounded" width={48} height={18} />

      <Skeleton variant="rounded" width={80} height={18} />

      <Stack spacing={1} direction="row">
        <Skeleton variant="rounded" width={20} height={20} />

        <Skeleton variant="rounded" width={40} height={20} />
      </Stack>
    </Stack>
  );
};

export const CareerCardSkeleton = () => {
  return (
    <StyledCareerCard>
      <Skeleton variant="rectangular" width={296} height={183} />

      <StyledOverallFitWrap>
        <Stack direction="row">
          <Skeleton variant="circular" width={8} height={8} />

          <Skeleton variant="circular" width={8} height={8} />

          <Skeleton variant="circular" width={8} height={8} />

          <Skeleton variant="circular" width={8} height={8} />

          <Skeleton variant="circular" width={8} height={8} />
        </Stack>

        <Skeleton sx={sxStyles.overallFitTitle} variant="rounded" width={96} height={16} />
      </StyledOverallFitWrap>

      <StyledCareerDetails>
        <Skeleton variant="rounded" height={22} />

        <Skeleton variant="rounded" height={22} />

        <Stack direction="row" spacing={2}>
          <InfographicItemSkeleton />

          <InfographicItemSkeleton />

          <InfographicItemSkeleton />
        </Stack>
      </StyledCareerDetails>

      <StyledActionsContainer>
        <ActionButton sx={sxStyles.favoriteBtn} variant="text" type="button">
          <Skeleton variant="rounded" width={21} height={20} />
        </ActionButton>

        <StyledMoreLink>
          <Skeleton variant="rounded" width={70} height={20} />
        </StyledMoreLink>
      </StyledActionsContainer>
    </StyledCareerCard>
  );
};
